// extracted by mini-css-extract-plugin
module.exports = {"cover":"LandingPageMovieSelectionCover_cover__Fr2Ro","img":"LandingPageMovieSelectionCover_img__98kaS"};